import Modal from "@components/atoms/Modal";
import { BMHModalProps } from "./types";
import { useTheme } from "styled-components/native";
import React, { useState } from "react";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useTranslation } from "react-i18next";
import BMHScreen from "./BMHScreen";
import { Platform } from "react-native";
import {
  KeyboardAvoidingView,
  KeyboardAwareScrollView,
} from "react-native-keyboard-controller";
import { Container } from "@components/atoms";
import { DynamicFormProvider } from "@scenes/bulk-request/context/DynamicFormContext";
import ReviewPageRequest from "@scenes/jewelry-builder/components/ReviewPageRequest";
import { ProductCategory } from "@utils/constants";

const BMHModal = ({
  isOpen,
  onClose,
  itemDetail,
  productType,
  externalPriceMode,
  initialSelectedOption,
  initialSelectedQuantity,
  onSelectedQuantityChange,
  fromReviewPage = false,
  setRequestData,
  toggleModal,
  additionalAttributes,
  modals,
  navigateToDeeplink,
  navigateToRequest,
}: BMHModalProps) => {
  const { t } = useTranslation();
  const [title, setTitle] = useState(t("bmh.title.memo.text"));
  const userInfo = useUserInfo();
  const PARequest = userInfo.isPAUser();
  const theme = useTheme();
  return (
    <Modal
      headerTitle={
        fromReviewPage
          ? t("reviewPage.request.popUp.title.text")
          : PARequest
          ? t("bmh.title.request.text")
          : title
      }
      isOpen={isOpen}
      onClose={onClose}
      paddingLeft={0}
      paddingRight={0}
      paddingTop={0}
      paddingBottom={0}
      enableToastMessage
      allowFullScreen={Platform.OS === "web" ? true : false}
      skipKeyboardAware={
        Platform.OS === "web" && theme.isTablet ? false : !theme.isLargeScreen
      }
      // webHeight={"80vh"}
    >
      <DynamicFormProvider>
        {Platform.OS === "web" ? (
          <KeyboardAvoidingView behavior={"height"} style={{ flex: 1 }}>
            <KeyboardAwareScrollView
              keyboardShouldPersistTaps="handled"
              contentContainerStyle={{ flexGrow: 1 }}
            >
              {fromReviewPage ? (
                <ReviewPageRequest
                  productType={productType}
                  priceMode={userInfo.getPriceMode()}
                  setRequestData={setRequestData}
                  toggleModal={toggleModal}
                  modals={modals}
                  navigateToDeeplink={navigateToDeeplink}
                  navigateToRequest={navigateToRequest}
                />
              ) : (
                <Container>
                  <BMHScreen
                    title={setTitle}
                    itemDetail={itemDetail}
                    onClose={onClose}
                    productType={productType as ProductCategory}
                    externalPriceMode={externalPriceMode}
                    initialSelectedOption={initialSelectedOption}
                    initialSelectedQuantity={initialSelectedQuantity}
                    onSelectedQuantityChange={onSelectedQuantityChange}
                    additionalAttributes={additionalAttributes}
                    fromPDPPage={!fromReviewPage}
                  />
                </Container>
              )}
            </KeyboardAwareScrollView>
          </KeyboardAvoidingView>
        ) : fromReviewPage ? (
          <ReviewPageRequest
            productType={productType}
            priceMode={userInfo.getPriceMode()}
            setRequestData={setRequestData}
            toggleModal={toggleModal}
            modals={modals}
            navigateToDeeplink={navigateToDeeplink}
            navigateToRequest={navigateToRequest}
          />
        ) : (
          <BMHScreen
            title={setTitle}
            itemDetail={itemDetail}
            onClose={onClose}
            productType={productType as ProductCategory}
            externalPriceMode={externalPriceMode}
            initialSelectedOption={initialSelectedOption}
            initialSelectedQuantity={initialSelectedQuantity}
            onSelectedQuantityChange={onSelectedQuantityChange}
            additionalAttributes={additionalAttributes}
            fromPDPPage={!fromReviewPage}
          />
        )}
      </DynamicFormProvider>
    </Modal>
  );
};

export default BMHModal;
